// extracted by mini-css-extract-plugin
module.exports = {"bi":"styles-module__bi___rMICE","edit":"styles-module__edit___3sx2P","buttonPadding":"styles-module__buttonPadding___S8gS9"};